import React from 'react';
import { EntityType } from 'src/models/paper';

export const EntityContext = React.createContext(EntityType.document);
EntityContext.displayName = 'EntityContext';

/* <MyContext.Provider> // "MyDisplayName.Provider" in DevTools */
/*  <MyContext.Consumer> // "MyDisplayName.Consumer" in DevTools */
